

























































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { Table } from '@/components/bwaff';
import { CardForm } from '@/components/bwaff';
import DomainsApi from '@/services/rest/bemob/domains';
import CampaignApi from '@/services/rest/bemob/campaign';
import moment from 'moment';
import GetUsingTypeMixin from '@/i18n/getUsingType-mixin';
import { mixins } from 'vue-class-component';
import Card from '@/stories/utils/card.vue';
import * as domain from 'domain';
import { StatusEnum } from '@/services/models/Enums';


@Component({
  computed: {
    domain() {
      return domain
    }
  },
  components: {
    Card,
    CardForm,
    DataTable: Table,
  }
})
export default class TrackingDomains extends mixins(GetUsingTypeMixin) {
  domainsApi: DomainsApi = new DomainsApi();
  campaignApi: CampaignApi = new CampaignApi();

  @Prop({ default:'DD MMM YYYY HH:mm' })
  format!: string;

  form: any = {};
  rowsPerPageCount: number = 10;

  async mounted() {
    if(!this.$store.state.cache.campaigns.isUploaded){
      await this.campaignApi.populateStoreCache()
    }
  }

  get campaignsListWithDefault(){
    return [
      {
        nameFull: this.t('Account default'),
        id: ''
      },
      ...this.$store.state.cache.campaigns.data
    ]
  }

  validDnsDate(item) {
    return moment(item.nextDnsRecordValidation).format(this.format)
  }

  checkDelete(id: string) {
    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      message: this.t('All selected items will be deleted permanently if you press OK.'),
        onConfirm: () => {
        this.$store.commit('loading', true);
        this.domainsApi.deleteTrackingDomain(id)
          .then(()=>{
            this.bus.emit('toast-success', this.t('Domain deleted'));
          })
          .catch((e: any)=>{
            for(let item of e.response?.data?.errors?.id[0]) {
              let usingType = this.getUsingType({type:item.usingType});
              let message = this.t('{0} is used by {1} {2}', [item.usedName,usingType,item.usingName]);

              this.bus.emit('toast-warning', message,{
                dontHide:true
              });
            }
        }).finally(()=> {
          this.$store.commit('loading', false);
        })
      },
    }})
  }

  setAsDefault(id: string) {
    this.$store.commit('loading', true);
    return this.domainsApi.updateUserDomainData({trackingDomainId: id}).then((res: any) => {
      this.$store.commit('updateUser', res);
    }).finally(()=>
      this.$store.commit('loading', false));
  }


  get headers() {
    return [
      {
        text: this.t('Domain'),
        value: 'domain',
        sortable: false
      },
      {
        text: this.t('Workspaces'),
        value: 'workspaces',
        sortable: false
      },
      {
        text: this.t('Domain\'s root'),
        value: 'setCampaign',
        sortable: false
      },
      {
        text: '',
        value: 'setMain',
        sortable: false
      },
      {
        text: '',
        value: 'action',
        sortable: false
      }
    ];
  }

  addCustomDomain() {
    this.bus.emit('open-dialog', {
      name: 'AddCustomTrackingDomainDialog'
    });
  }

  onCampaignChange({ item,value }) {
    if(typeof value==='undefined' || item.campaignId === value) return;
    this.$store.commit('loading', true);
    this.$store.commit('cacheStartUpdating', {cacheProperty:'trackingDomains'});
    this.domainsApi.putTrackingDomain(item.id, {
      campaignId: value
    })
      .finally(()=> {
        this.$store.commit('loading', false);
      })
  }

  get fetchCampaignOptions(){
    if(this.$store.state.cache.campaigns.isAllInCache){
      return
    }
    return ({ search })=>this.campaignApi.getList({
      status: StatusEnum.active,
      search,
      limit:200,
      orderBy:'updated',
      orderDirection:'desc',
    }).then((res)=>{
      return res
    })
  }

  isNextDnsRecordValidationAfterYear(item) {
    return moment().add(1, 'year').isBefore(item.nextDnsRecordValidation)
  }
}
